<template>
  <div class="item-selector">
    <div class="">
      <div v-if="item.item_id" class="selected-item">
        {{ item.part_number }}
        <!-- <span class="deselect-icon" @click="deselectItem(item, index)">
          <font-awesome-icon icon="times-circle" />
        </span> -->
      </div>
      <base-select
        v-else
        v-model="itemSelect"
        :options="itemOptions"
        :show-labels="false"
        :preserve-search="true"
        :initial-search="item.part_number"
        :invalid="invalid"
        :placeholder="$t('invoices.item.select_an_item')"
        label="part_number"
        class="multi-select-item"
        @select="(val) => $emit('select', val)"
      >
      </base-select>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      default: null
    },
    invalid: {
      type: Boolean,
      required: false,
      default: false
    },
    invalidDescription: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data () {
    return {
      itemSelect: null,
      loading: false,
      type:'',
      addItemButtonShow:true,
      itemOptions:[]
    }
  },
  computed: {
    ...mapGetters('item', [
      'items'
    ]),
    ...mapGetters('deliveryNote', [
      'POItems',
      'deliveryNoteItems',
      'availableDeliveryNoteItems',
      'deliveryNoteItemsStatus',
      'POHasItems'
    ]),
  },
  watch: {
    invalidDescription (newValue) {
      console.log(newValue)
    }
  },
  created(){
    this.deliveryNoteType();
  },
  methods: {
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('item', [
      'fetchItems'
    ]),
    async deliveryNoteType(){
      if (this.$route.name === 'delivery-notes.edit') {
        if(this.POHasItems == true && this.deliveryNoteItemsStatus== true){
          if(this.POItems){
            this.itemOptions = this.POItems
          }
        }else if(this.deliveryNoteItemsStatus ==true ){
          this.itemOptions = this.availableDeliveryNoteItems
        }else{
          this.itemOptions = this.availableDeliveryNoteItems
        }
      }
    },
    async searchItems (search) {
      let data = {
        filter: {
          name: search,
          price: ''
        },
        orderByField: '',
        orderBy: '',
        page: 1
      }

      this.loading = true
      if (this.$route.name === 'invoices.edit' && this.invoiceHasPO==false) {
        await this.fetchItems(data)
      }

      this.loading = false
    },
    onTextChange (val) {
      this.searchItems(val)

      this.$emit('search', val)
    },
    openItemModal () {
      this.$emit('onSelectItem')
      this.openModal({
        'title': 'Add Item',
        'componentName': 'ItemModal',
        'data': {taxPerItem: this.taxPerItem, taxes: this.taxes}
      })
    },
    deselectItem(item, index) {
      this.itemSelect = null
      this.$emit('deselect',  item, index)
    }
  }
}
</script>
